import { render, staticRenderFns } from "./ComplaintInfoPopup.vue?vue&type=template&id=9a74848e&scoped=true"
import script from "./ComplaintInfoPopup.vue?vue&type=script&lang=js"
export * from "./ComplaintInfoPopup.vue?vue&type=script&lang=js"
import style0 from "./ComplaintInfoPopup.vue?vue&type=style&index=0&id=9a74848e&prod&scoped=true&lang=css"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=9a74848e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a74848e",
  null
  
)

export default component.exports